export const lessonControllerHeight = (mode: any, system: 'catiz3' | 's80') =>
  system === 'catiz3'
    ? mode === 'demo'
      ? 150
      : 350
    : mode === 'demo'
    ? 150
    : 365;
